import { FunctionComponent } from "react";
import {
  TextInputWithRegister,
  DropdownWithRegister,
  TermsAndConditions,
} from "../../inputs";
import { FieldErrors } from "react-hook-form";
import { forms } from "src/utils";

export interface IClientRegistrationFormValues {
    name: string
    email: string
    dob: string
    password: string
    phone: string
    address: string
    city: string
    state: string
    zip: string
    gender: "MALE",
    termsAndConditions: false,
}

interface IClientRegistrationFormProps {
  register: Function;
  errors: FieldErrors
}

const ClientRegistrationForm: FunctionComponent<IClientRegistrationFormProps> = ({ register, errors }) => {
  // const [params] = useSearchParams();
  // const [credit, setCredit] = useState<boolean>(false);
  // const [client, setClient] = useState<Client | null>(null);

  // const company = params.get("referrer") || "";
  // const member = params.get("fe") || "";

  // const submit: SubmitHandler<any> = async (data) => {
  //   const { email, password, name, phone } = data;

  //   try {
  //     // Add to cognito user pool
  //     const result = await auth.cognito.registerCognitoUser(email, password);

  //     const uid =
  //       result?.userSub ||
  //       `${Math.random().toFixed(4)}-${Math.random().toFixed(4)}`.replaceAll(
  //         ".",
  //         "e"
  //       );

  //     // Add to Informativ user pool
  //     const ipResult = await axios.get("https://api.ipify.org?format=json");
  //     const informativResult = await informativ.creditUsers.addCreditUser({
  //       uid,
  //       name,
  //       email,
  //       password,
  //       ip: ipResult.data.ip,
  //     });
  //     const convertedResult = convert.xml2js(informativResult, {
  //       compact: true,
  //     });

  //     // Add to Stripe customer list
  //     const customer = await stripe.customers.addNewCustomer(
  //       name,
  //       email,
  //       phone
  //     );

  //     // // Format & Add to DynamoDB
  //     const client = format.users.userDataToClient(data, uid, company, member);

  //     client.metadata.cus_id =
  //       //@ts-ignore
  //       convertedResult["XML_INTERFACE"]["CUS_ID"]["_text"];
  //     client.metadata.stripeId = customer?.id;

  //     await dynamo.mutations.putUser(client);

  //     setClient(client);
  //     setCredit(true);
  //   } catch (error) {
  //     console.log({ error });
  //   }
  // };

  return (
        <form className="grid grid-cols-2">
          <TextInputWithRegister
            label="Name"
            id="name"
            placeholder="Full name..."
            containerStyles="lg:w-[85%]"
            register={register("name")}
            error={errors?.name?.message}
          />

      <TextInputWithRegister
        label="dob"
        id="dob"
        placeholder="MM/DD/YYYY"
        containerStyles="lg:w-[85%]"
        register={register("dob", {
          onChange: (e: any) => {
            let value = e.target.value.replace(/\D/g, ""); // only digits
            if (value.length > 8) value = value.slice(0, 8);

            // Add slashes: MM/DD/YYYY
            if (value.length > 4) {
              value = `${value.slice(0, 2)}/${value.slice(2, 4)}/${value.slice(
                4
              )}`;
            } else if (value.length > 2) {
              value = `${value.slice(0, 2)}/${value.slice(2)}`;
            }

            e.target.value = value;
          },
        })}
        error={errors?.dob?.message}
      />

      <TextInputWithRegister
        label="Email"
        id="email"
        placeholder="Enter email address..."
        containerStyles="lg:w-[85%]"
        register={register("email")}
        error={errors?.email?.message}
      />

      <TextInputWithRegister
        label="Password"
        id="password"
        placeholder="Enter password..."
        containerStyles="lg:w-[85%]"
        password
        showPasswordToggle
        register={register("password")}
        error={errors?.password?.message}
      />

      <TextInputWithRegister
        label="Phone"
        id="phone"
        placeholder="Enter phone number..."
        containerStyles="lg:w-[85%]"
        register={register("phone", {
          onChange: (e: any) => {
            let value = e.target.value.replace(/\D/g, ""); // keep only numbers
            if (value.length > 10) value = value.slice(0, 10);

            if (value.length > 6) {
              value = `(${value.slice(0, 3)})${value.slice(3, 6)}-${value.slice(
                6
              )}`;
            } else if (value.length > 3) {
              value = `(${value.slice(0, 3)})${value.slice(3)}`;
            } else if (value.length > 0) {
              value = `(${value}`;
            }

            e.target.value = value;
          },
        })}
        error={errors?.phone?.message}
      />

      <TextInputWithRegister
        label="Address"
        id="address"
        placeholder="Enter address..."
        containerStyles="lg:w-[85%]"
        register={register("address")}
        error={errors?.address?.message}
      />

      <TextInputWithRegister
        label="City"
        id="city"
        placeholder="Enter city..."
        containerStyles="lg:w-[85%]"
        register={register("city")}
        error={errors?.city?.message}
      />

      <TextInputWithRegister
        label="State"
        id="state"
        placeholder="Enter state..."
        containerStyles="lg:w-[85%]"
        register={register("state", {
          onChange: (e: any) => {
            let value = e.target.value;
            if (value.length > 2) value = value.slice(0, 2);
            e.target.value = value;
          },
        })}
        error={errors?.state?.message}
      />

      <TextInputWithRegister
        label="Zip"
        id="zip"
        placeholder="Enter zip code..."
        containerStyles="lg:w-[85%]"
        register={register("zip")}
        error={errors?.zip?.message}
      />

      <DropdownWithRegister
        id="gender"
        register={register}
        options={forms.dropdown.genderOptions}
        error={errors?.gender?.message}
      />

      <TermsAndConditions
        register={register}
        error={errors?.termsAndConditions?.message}
      />
    </form>
  )
};

export default ClientRegistrationForm;

